<div class="form-modal">
  <mat-dialog-content>
    <div class="img-wrapper">
      <div class="title-wrapper">
        <h1>{{ isEditing ? 'Edit' : isNew ? 'Create New' : 'View' }} Template</h1>
      </div>
    </div>

    <form [formGroup]="templateForm" (ngSubmit)="onSubmit()" class="template-form">
      <div class="form-wrapper-80">
        <div class="form-group org-type-group">
          <span class="required">*</span><label class="org-type-label">Organization Type:</label>
          <mat-radio-group [disabled]="isViewMode()" formControlName="OrgType" class="org-type-radio-group" [(ngModel)]="selectedOrgType">
            <mat-radio-button
              *ngFor="let org of organizationTypes"
              [value]="org.id"
              class="org-type-radio"
            >
              {{ org.name }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="form-group title-row">
          <div for="title" class="title-label">
            <span class="required">*</span>Title: 
          </div>
          <input 
            [readonly]="isViewMode()"
            matInput
            id="title"
            formControlName="Title"
            class="wt-mat-input"
            placeholder="Template Title"
            type="text"
            [ngClass]="{'invalid': templateForm.get('Title')?.invalid && (templateForm.get('Title')?.touched || submitButtonPressed)}"
          />
        </div>
        <div *ngIf="templateForm.get('Title')?.invalid && (templateForm.get('Title')?.touched || submitButtonPressed)" class="error-message">
          Title is required.
        </div>

        <div class="form-group">
          <label for="content"><span class="required">*</span>Content:</label>
          <ckeditor id="content" [readonly]="isViewMode()" formControlName="Content" [config]="config"></ckeditor>
        </div>
        <div *ngIf="templateForm.get('Content')?.invalid && (templateForm.get('Content')?.touched || submitButtonPressed)" class="error-message">
          Content is required.
        </div>

        <div class="form-group">
          <label for="link"><b>Optional:</b> Select the Content to Link in Message</label>
          <mat-form-field appearance="outline" class="wt-mat-form-field">
            <mat-select id="link" [disabled]="isViewMode()" formControlName="Link" placeholder="None" (selectionChange)="onLinkSelect($event.value)">
              <mat-option *ngFor="let link of linkOptions" [value]="link">{{ link }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fixed-footer">
          <a tabindex="0" class="btn-primary btn-bold btn" (click)="onSubmit()" (keypress)="onSubmit()">
            {{ isEditing ? 'Update Template' : isNew ? 'Add Template' : 'Close' }}
          </a>
        </div>
      </div>
    </form>
  </mat-dialog-content>
</div> 